import { faFlushed } from "@fortawesome/free-solid-svg-icons";

export const createProject = (project) => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		// make async call to database
		const firestore = getFirestore();
		const profile = getState().firebase.profile;
		const authorId = getState().firebase.auth.uid;

		firestore.collection('projects').add({
			...project,
			authorFirstName: profile.firstName,
			authorLastName: profile.lastName,
			authorId: authorId,
			createdAt: new Date(),
			finalized: false
		}).then(() => {
			dispatch({ type: 'CREATE_PROJECT', project: project });
		}).catch((err) => {
			dispatch({ type: 'CREATE_PROJECT_ERROR', err })
		})

	}
};

export const incrementCount = () => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		// make async call to database
		const firestore = getFirestore();
		const profile = getState().firebase.profile;
		const authorId = getState().firebase.auth.uid;

		const dateObj = new Date();
		const month = dateObj.getUTCMonth() + 1;
		const year = dateObj.getUTCFullYear();

		let newValue

		const lastUpdatedM = profile.lastUpdatedM
		const lastUpdatedY = profile.lastUpdatedY

		if ((lastUpdatedM !== month || lastUpdatedY !== year)) {
			newValue = {
				lastUpdatedM: month,
				lastUpdatedY: year,
				createCount: 1
			}
		} else if ((lastUpdatedM === month && lastUpdatedY === year)) {
			let currentValue = profile.createCount
			newValue = {
				createCount: currentValue + 1
			}
		}

		firestore.update({ collection: 'users', doc: authorId }, newValue
		)
			.then(() => {
				getState().firebase.updateProfile(newValue)
			})
			.then(() => {
				dispatch({ type: 'INCREMENT_COUNT', project: authorId });
			}).catch((err) => {
				dispatch({ type: 'INCREMENT_COUNT_ERROR', err })
			})
	}
}

export const discardProject = (projectId) => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		// make async call to database
		const firestore = getFirestore();
		// const profile = getState().firebase.profile;
		// const authorId = getState().firebase.auth.uid;

		firestore.collection('projects').doc(projectId).delete().then(() => {
			dispatch({ type: 'DISCARD_PROJECT' });
		}).catch((err) => {
			dispatch({ type: 'DISCARD_PROJECT_ERROR', err })
		})

	}
};

export const registerSign = (imageurl) => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		// make async call to database
		const firestore = getFirestore();
		// const profile = getState().firebase.profile;
		const authorId = getState().firebase.auth.uid;
		// const projectId = getState().firebase.project;
		const itemUpdates = {
			esign: imageurl
		}
		firestore.update({ collection: 'users', doc: authorId }, itemUpdates
		)
			.then(() => {
				getState().firebase.updateProfile(itemUpdates)
			})
			.then(() => {
				dispatch({ type: 'REGISTER_SIGN', project: authorId });
			}).catch((err) => {
				dispatch({ type: 'REGISTER_SIGN_ERROR', err })
			})

	}
};


export const signProject = (projectId, withCompany2, password) => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		const firestore = getFirestore();
		const authorId = getState().firebase.auth.uid;
		const esign2 = getState().firebase.profile.esign;
		const privateAddress2 = getState().firebase.profile.privateAddress
		const companyName2 = getState().firebase.profile.companyName
		const companyTitle2 = getState().firebase.profile.companyTitle
		const companyAddress2 = getState().firebase.profile.companyAddress
		// const withCompany2 = state.withCompany2



		// const projectId = getState().firebase.project;
		const itemUpdates = {
			// ...state,
			authorId2: authorId,
			sign2: true,
			esign2: esign2,
			privateAddress2: privateAddress2,
			companyName2: companyName2,
			companyTitle2: companyTitle2,
			companyAddress2: companyAddress2,
			withCompany2: withCompany2,
			signedAt: new Date(),
			finalized: true,
			password: password
		}
		firestore.update({ collection: 'projects', doc: projectId }, itemUpdates)
			.then(() => {
				firestore.set({ collection: 'signs', doc: projectId }, { projectId: projectId })
			})
			.then(() => {
				dispatch({ type: 'SIGN_PROJECT', project: projectId });
			}).catch((err) => {
				dispatch({ type: 'SIGN_PROJECT_ERROR', err })
			})

	}
};

export const updateProfile = (newProfile) => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		// make async call to database
		const firestore = getFirestore();
		// const profile = getState().firebase.profile;
		const authorId = getState().firebase.auth.uid;
		// const projectId = getState().firebase.project;
		const itemUpdates = {
			privateAddress: newProfile.privateAddress,
			companyName: newProfile.companyName,
			companyTitle: newProfile.companyTitle,
			companyAddress: newProfile.companyAddress
		}
		firestore.update({ collection: 'users', doc: authorId }, itemUpdates
		).then(() => {
			dispatch({ type: 'UPDATE_USER_PROFILE', project: authorId });
		}).catch((err) => {
			dispatch({ type: 'UPDATE_USER_PROFILE_ERROR', err })
		})

	}
};

export const addStripeToken = (token) => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		// make async call to database
		const firestore = getFirestore();
		// const profile = getState().firebase.profile;
		const authorId = getState().firebase.auth.uid;
		// const projectId = getState().firebase.project;
		firestore
			.collection('stripe_customers')
			.doc(authorId)
			.collection('tokens')
			.add({ token: token.token.id })

			.then(() => {
				dispatch({ type: 'ADD_PAYMENT_METHOD' });
			}).catch((err) => {
				dispatch({ type: 'ADD_PAYMENT_METHOD_ERROR', err })
			})

	}
};

export const unsubscribeStripe = () => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		// make async call to database
		const firestore = getFirestore();
		// const profile = getState().firebase.profile;
		const authorId = getState().firebase.auth.uid;
		// const projectId = getState().firebase.project;
		firestore
			.collection('users')
			.doc(authorId)
			.update({ plan: null })
			.then(() => {
				dispatch({ type: 'UNSUBSCRIBE_STRIPE' });
			}).catch((err) => {
				dispatch({ type: 'UNSUBSCRIBE_STRIPE_ERROR', err })
			})

	}
};

export const submitNewCharge = (token) => {
	return (dispatch, getState, { getFirebase, getFirestore }) => {
		// make async call to database
		const firestore = getFirestore();
		// const profile = getState().firebase.profile;
		const authorId = getState().firebase.auth.uid;
		// const projectId = getState().firebase.project;
		firestore
			.collection('stripe_customers')
			.doc(authorId)
			.collection('tokens')
			.add({ token: token.token.id })
			.then(() => {
				dispatch({ type: 'ADD_PAYMENT_METHOD' });
			}).catch((err) => {
				dispatch({ type: 'ADD_PAYMENT_METHOD_ERROR', err })
			})

	}
};

// const itemUpdates =  {
// 	some: 'value',
// 	signedAt: store.firestore.FieldValue.serverTimestamp()
//   }

//   store.firestore.update({ collection: 'cities', doc: 'SF' }, itemUpdates),